export default __webpack_public_path__ + "static/onmydev_terms_of_use_v1.0-303c713f1963b004daa0954115ff8631.pdf";